import React from 'react';
import { Link } from 'react-router-dom';
import './AlphabetNav.css';

const AlphabetNav = () => {
  const letters = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)); // A-Z

  return (
    <nav className="alphabet-nav">
      {letters.map((letter) => (
        <Link key={letter} to={`/learn/alphabet/${letter.toLowerCase()}`} className="block-letter">
          {letter}
        </Link>
      ))}
    </nav>
  );
};

export default AlphabetNav;
